import {
  VGDistInfoService
} from '@nuskin/ns-account'


const mapIdsToDisplayNames = async (ids) => {
  // make sure they're unique
  ids = [...new Set(ids)]

  // look them up
  let users
  try {
    users = await Promise.all(
      ids.map(VGDistInfoService.searchDownline)
    )
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
    users = []
  }

  // and make a nice map so we can look up names by SAP ID
  return users
    .filter(item => item.length > 0)
    .map(item => item[0])
    .reduce((result, currentItem) => {
      result[currentItem.sapId] = currentItem.name
      return result
    }, {})
}

export {
  mapIdsToDisplayNames
}
